const crystalGuideStoryDesignerOrigin = window.__AUCELIA_DESIGNER_ORIGIN__ || 'https://aucelia-designer.aucelia-studio.workers.dev';
const zodiacStories = [
  {
    key: 'aries',
    sign: 'Aries',
    designId: 'zodiac-aries-spark',
    name: 'Aries',
    dates: 'MAR 21 — APR 19',
    accent: '#7c342f',
    glyph: '♈︎',
    image: 'aucelia-zodiac-sign-01-aries.webp',
    imageAlt: 'Aries natural crystal material study',
    direction: 'Deep red accent · clear beginning',
    story: 'Deep red beads sit against cool grey stone with a concentrated, deliberate colour. Restraint and open space allow the red itself to become the first point of focus.'
  },
  {
    key: 'taurus',
    sign: 'Taurus',
    designId: 'zodiac-taurus-garden',
    name: 'Taurus',
    dates: 'APR 20 — MAY 20',
    accent: '#49623f',
    glyph: '♉︎',
    image: 'aucelia-zodiac-sign-02-taurus.webp',
    imageAlt: 'Taurus natural crystal material study',
    direction: 'Deep green mineral · quiet weight',
    story: 'Earthy green mineral texture takes the lead with a calm, grounded weight. The scene stays tactile and substantial without adding unnecessary decoration.'
  },
  {
    key: 'gemini',
    sign: 'Gemini',
    designId: 'zodiac-gemini-light',
    name: 'Gemini',
    dates: 'MAY 21 — JUN 20',
    accent: '#496b7c',
    glyph: '♊︎',
    image: 'aucelia-zodiac-sign-03-gemini.webp',
    imageAlt: 'Gemini natural crystal material study',
    direction: 'Clear light · paired focus',
    story: 'Clear quartz carries the full composition with two related points of focus. Transparency, small internal details and open spacing keep the material light and alert.'
  },
  {
    key: 'cancer',
    sign: 'Cancer',
    designId: 'zodiac-cancer-moon',
    name: 'Cancer',
    dates: 'JUN 21 — JUL 22',
    accent: '#55656d',
    glyph: '♋︎',
    image: 'aucelia-zodiac-sign-04-cancer.webp',
    imageAlt: 'Cancer natural crystal material study',
    direction: 'Soft white lustre · quiet space',
    story: 'Soft white light moves slowly across the bead surface instead of flashing directly. Calm spacing allows that subtle lustre to carry the whole story.'
  },
  {
    key: 'leo',
    sign: 'Leo',
    designId: 'zodiac-leo-sun',
    name: 'Leo',
    dates: 'JUL 23 — AUG 22',
    accent: '#8b5615',
    glyph: '♌︎',
    image: 'aucelia-zodiac-sign-05-leo.webp',
    imageAlt: 'Leo natural crystal material study',
    direction: 'Warm gold · singular focus',
    story: 'Warm colour does not need to fill the entire bracelet. Placed where the light lands first, one clear focal point is enough to illuminate the whole composition.'
  },
  {
    key: 'virgo',
    sign: 'Virgo',
    designId: 'zodiac-virgo-herbarium',
    name: 'Virgo',
    dates: 'AUG 23 — SEP 22',
    accent: '#4f6251',
    glyph: '♍︎',
    image: 'aucelia-zodiac-sign-06-virgo.webp',
    imageAlt: 'Virgo natural crystal material study',
    direction: 'Natural detail · ordered variation',
    story: 'Small differences in clarity, bead diameter and natural texture create an order of their own. Precision need not feel rigid; a little genuine variation makes the result more beautiful.'
  },
  {
    key: 'libra',
    sign: 'Libra',
    designId: 'zodiac-libra-rose',
    name: 'Libra',
    dates: 'SEP 23 — OCT 22',
    accent: '#8f5664',
    glyph: '♎︎',
    image: 'aucelia-zodiac-sign-07-libra.webp',
    imageAlt: 'Libra natural crystal material study',
    direction: 'Soft rose · balanced space',
    story: 'Soft rose quartz keeps the composition warm and calm. Two subtle groups balance across the surface with enough open space for the pale material to feel light.'
  },
  {
    key: 'scorpio',
    sign: 'Scorpio',
    designId: 'zodiac-scorpio-nocturne',
    name: 'Scorpio',
    dates: 'OCT 23 — NOV 21',
    accent: '#242629',
    glyph: '♏︎',
    image: 'aucelia-zodiac-sign-08-scorpio.webp',
    imageAlt: 'Scorpio natural crystal material study',
    direction: 'Obsidian depth · dark contrast',
    story: 'Black obsidian gathers the light close against charcoal stone, revealing texture only at a nearer look. Small reflections and open intervals give the dark mineral its depth.'
  },
  {
    key: 'sagittarius',
    sign: 'Sagittarius',
    designId: 'zodiac-sagittarius-horizon',
    name: 'Sagittarius',
    dates: 'NOV 22 — DEC 21',
    accent: '#9a552b',
    glyph: '♐︎',
    image: 'aucelia-zodiac-sign-09-sagittarius.webp',
    imageAlt: 'Sagittarius natural crystal material study',
    direction: 'Warm carnelian · lively rhythm',
    story: 'Warm carnelian opens outward through a focused red-orange note. An energetic but unforced arrangement gives the mineral a sense of movement without filling every space.'
  },
  {
    key: 'capricorn',
    sign: 'Capricorn',
    designId: 'zodiac-capricorn-stone',
    name: 'Capricorn',
    dates: 'DEC 22 — JAN 19',
    accent: '#554c43',
    glyph: '♑︎',
    image: 'aucelia-zodiac-sign-10-capricorn.webp',
    imageAlt: 'Capricorn natural crystal material study',
    direction: 'Smoky structure · restrained layers',
    story: 'Smoky quartz carries the weight through its deep grey-brown clarity. A grounded structure and clean outline let the material feel strong without excess detail.'
  },
  {
    key: 'aquarius',
    sign: 'Aquarius',
    designId: 'zodiac-aquarius-current',
    name: 'Aquarius',
    dates: 'JAN 20 — FEB 18',
    accent: '#416678',
    glyph: '♒︎',
    image: 'aucelia-zodiac-sign-11-aquarius.webp',
    imageAlt: 'Aquarius natural crystal material study',
    direction: 'Cool clarity · unexpected variation',
    story: 'A little irregularity keeps cool transparency from feeling too uniform. Alternating levels of clarity give the details a more contemporary character.'
  },
  {
    key: 'pisces',
    sign: 'Pisces',
    designId: 'zodiac-pisces-dream',
    name: 'Pisces',
    dates: 'FEB 19 — MAR 20',
    accent: '#695b83',
    glyph: '♓︎',
    image: 'aucelia-zodiac-sign-12-pisces.webp',
    imageAlt: 'Pisces natural crystal material study',
    direction: 'Soft violet · softened edges',
    story: 'Lavender amethyst moves gently between transparent and misted violet. Soft boundaries and a calm reflective surface make the material feel fluid without becoming decorative.'
  }
];

function encodeCompactHandoff(payload) {
  const compact = {
    v: 1,
    e: payload.entry_mode,
    m: '',
    b: '',
    a: '',
    z: payload.zodiac,
    d: payload.design_direction,
    s: []
  };
  const bytes = new TextEncoder().encode(JSON.stringify(compact));
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function buildZodiacStory() {
  const section = document.querySelector('.aucelia-crystal-personal-energy__zodiac');
  if (!section || section.dataset.storyPreviewReady === 'true') return;

  const originalLinks = [...section.querySelectorAll('[data-zodiac-sign]')];
  const assetUrl = (filename) => window.__AUCELIA_CRYSTAL_GUIDE_ASSETS__?.[filename] || filename;

  section.className = 'aucelia-crystal-personal-energy__zodiac aucelia-zodiac-story-preview';
  section.dataset.storyPreviewReady = 'true';
  section.innerHTML = `
    <header class="aucelia-zodiac-story__header">
      <p class="aucelia-zodiac-story__eyebrow">ZODIAC MARKS / MATERIAL STORIES</p>
      <div class="aucelia-zodiac-story__heading-row">
        <h3 id="zodiac-stories-title"><span>Twelve zodiac marks,</span><span>twelve material studies.</span></h3>
        <p>Select a zodiac mark to change the image, palette and material story together. Each photograph is a colour-and-material study, not an official zodiac stone or efficacy claim.</p>
      </div>
    </header>
    <div class="aucelia-zodiac-story__layout">
      <div class="aucelia-zodiac-story__tabs" role="tablist" aria-label="Choose a zodiac story">
        ${zodiacStories.map((story, index) => `
          <button type="button" role="tab" id="zodiac-story-tab-${story.key}" data-story-index="${index}" aria-controls="zodiac-story-copy" aria-selected="${index === 0 ? 'true' : 'false'}" aria-label="${story.name}，${story.dates}" tabindex="${index === 0 ? '0' : '-1'}">
            <span class="aucelia-zodiac-story__tab-badge" aria-hidden="true"><span>${story.glyph}</span></span>
            <strong>${story.name}</strong>
          </button>
        `).join('')}
      </div>
      <figure class="aucelia-zodiac-story__visual" id="zodiac-story-visual">
        <img data-story-image data-asset="${assetUrl(zodiacStories[0].image)}" src="${assetUrl(zodiacStories[0].image)}" alt="${zodiacStories[0].imageAlt}" width="1122" height="1402" loading="eager" fetchpriority="high" decoding="async">
        <div class="aucelia-zodiac-story__visual-badge" aria-hidden="true">
          <span data-story-glyph>${zodiacStories[0].glyph}</span>
          <small data-story-badge-number>01</small>
        </div>
        <figcaption>
          <span data-story-count>01 / 12</span>
          <span data-story-dates>MAR 21 — APR 19</span>
        </figcaption>
      </figure>
      <article class="aucelia-zodiac-story__copy" id="zodiac-story-copy" role="tabpanel" aria-labelledby="zodiac-story-tab-aries">
        <p class="aucelia-zodiac-story__chapter" data-story-chapter>ARIES / AUCELIA VISUAL STUDY</p>
        <h4 data-story-title>Aries</h4>
        <p class="aucelia-zodiac-story__narrative" data-story-copy></p>
        <p class="aucelia-zodiac-story__direction">
          <span>Visual direction</span>
          <strong data-story-direction></strong>
        </p>
        <a class="aucelia-zodiac-story__cta" data-story-cta href="#">
          <span>Design from this material story</span>
          <span aria-hidden="true">→</span>
        </a>
        <div class="aucelia-zodiac-story__controls" aria-label="Change zodiac story">
          <button type="button" data-story-previous><span aria-hidden="true">←</span><span>Previous</span></button>
          <button type="button" data-story-next><span>Next</span><span aria-hidden="true">→</span></button>
        </div>
      </article>
    </div>
    <p class="aucelia-zodiac-story__status" data-story-status aria-live="polite"></p>
    <p class="aucelia-zodiac-story__note">Zodiac is used here only as a visual index. The photographs are arranged by colour and material atmosphere; they do not imply fixed zodiac-stone correspondences, predictions, personality judgements or crystal benefits.</p>
  `;

  const tabs = [...section.querySelectorAll('[data-story-index]')];
  const count = section.querySelector('[data-story-count]');
  const dates = section.querySelector('[data-story-dates]');
  const image = section.querySelector('[data-story-image]');
  const visualGlyph = section.querySelector('[data-story-glyph]');
  const badgeNumber = section.querySelector('[data-story-badge-number]');
  const chapter = section.querySelector('[data-story-chapter]');
  const title = section.querySelector('[data-story-title]');
  const copy = section.querySelector('[data-story-copy]');
  const direction = section.querySelector('[data-story-direction]');
  const cta = section.querySelector('[data-story-cta]');
  const panel = section.querySelector('[role="tabpanel"]');
  const status = section.querySelector('[data-story-status]');
  const previous = section.querySelector('[data-story-previous]');
  const next = section.querySelector('[data-story-next]');
  let currentIndex = 0;
  let storyImageRequestId = 0;

  function buildRoute(story) {
    const url = new URL('/designer', crystalGuideStoryDesignerOrigin);
    const payload = {
      entry_mode: 'zodiac',
      zodiac: story.sign,
      zodiac_dates: story.dates,
      design_direction: story.direction
    };
    url.searchParams.set('mode', 'guided');
    url.searchParams.set('source', 'crystal-guide');
    url.searchParams.set('entry', 'zodiac');
    url.searchParams.set('zodiac', story.key);
    url.searchParams.set('handoff', encodeCompactHandoff(payload));
    return { url: url.toString(), payload };
  }

  function applyStoryState(story, route, announce) {
    const storyIndex = zodiacStories.indexOf(story);
    section.style.setProperty('--story-accent', story.accent);
    section.classList.remove('is-story-changing');
    void section.offsetWidth;
    section.classList.add('is-story-changing');
    count.textContent = `${String(storyIndex + 1).padStart(2, '0')} / 12`;
    dates.textContent = story.dates;
    image.src = assetUrl(story.image);
    image.alt = story.imageAlt;
    image.dataset.asset = assetUrl(story.image);
    visualGlyph.textContent = story.glyph;
    badgeNumber.textContent = String(storyIndex + 1).padStart(2, '0');
    chapter.textContent = `${story.sign.toUpperCase()} / AUCELIA VISUAL STUDY`;
    title.textContent = story.name;
    copy.textContent = story.story;
    direction.textContent = story.direction;
    cta.href = route.url;
    cta.dataset.storyPayload = JSON.stringify(route.payload);
    panel.setAttribute('aria-labelledby', `zodiac-story-tab-${story.key}`);
    if (announce) status.textContent = `${story.name} selected. The image and material story have been updated.`;

    tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === storyIndex;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      tab.classList.toggle('is-active', active);
    });
  }

  function render(index, focusTab = false, scrollTab = true, announce = true) {
    currentIndex = (index + zodiacStories.length) % zodiacStories.length;
    const story = zodiacStories[currentIndex];
    const route = buildRoute(story);
    const imageUrl = assetUrl(story.image);
    const imageRequest = ++storyImageRequestId;
    const commit = () => {
      if (imageRequest !== storyImageRequestId) return;
      applyStoryState(story, route, announce);

      const activeTab = tabs[currentIndex];
      if (scrollTab) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        activeTab?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
      if (focusTab) activeTab?.focus();
      window.setTimeout(() => section.classList.remove('is-story-changing'), 320);
    };

    if (image.dataset.asset === imageUrl) {
      commit();
      return;
    }

    const preload = new Image();
    preload.decoding = 'async';
    preload.src = imageUrl;
    const commitImage = () => {
      if (imageRequest !== storyImageRequestId) return;
      image.src = imageUrl;
      image.alt = story.imageAlt;
      image.dataset.asset = imageUrl;
      commit();
    };
    if (typeof preload.decode === 'function') {
      preload.decode().then(commitImage, commitImage);
    } else {
      preload.onload = commitImage;
      preload.onerror = commitImage;
    }
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => render(index));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') return render(0, true);
      if (event.key === 'End') return render(zodiacStories.length - 1, true);
      const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      render(index + (forward ? 1 : -1), true);
    });
  });

  previous.addEventListener('click', () => render(currentIndex - 1));
  next.addEventListener('click', () => render(currentIndex + 1));
  cta.addEventListener('click', () => {
    try {
      window.sessionStorage.setItem('auceliaCrystalGuideHandoff', cta.dataset.storyPayload || '{}');
    } catch (error) {
      return;
    }
  });

  render(0, false, false, false);
}

function normaliseCrystalGuideRoutes() {
  const heroCta = document.querySelector('.aucelia-crystal-guide-hero__primary-cta');
  if (heroCta) {
    heroCta.href = new URL('/birth-intake?source=crystal-guide&entry=hero', crystalGuideStoryDesignerOrigin).href;
  }

  const section = document.querySelector('[data-aucelia-birthstone-story]');
  if (!section || section.dataset.localRoutesReady === 'true') return;

  const continueLink = section.querySelector(
    '.aucelia-crystal-personal-energy__actions .aucelia-crystal-personal-energy__primary:not([data-deeper-direction])'
  );
  const selectedMonthLink = section.querySelector('[data-deeper-direction]');
  const monthButtons = [...section.querySelectorAll('.aucelia-crystal-personal-energy__months button[data-month]')];
  continueLink?.remove();
  if (selectedMonthLink) {
    selectedMonthLink.classList.remove('aucelia-crystal-personal-energy__deeper');
    selectedMonthLink.classList.add('aucelia-crystal-personal-energy__primary');

    const syncMonthRoute = () => {
      const activeIndex = monthButtons.findIndex((button) => button.getAttribute('aria-pressed') === 'true');
      const index = activeIndex >= 0 ? activeIndex : 0;
      const existing = new URL(selectedMonthLink.href, window.location.href);
      const url = new URL('/designer', crystalGuideStoryDesignerOrigin);
      url.searchParams.set('mode', 'guided');
      url.searchParams.set('source', 'crystal-guide');
      url.searchParams.set('entry', 'month');
      url.searchParams.set('month', String(index + 1).padStart(2, '0'));
      const handoff = existing.searchParams.get('handoff');
      if (handoff) url.searchParams.set('handoff', handoff);
      selectedMonthLink.href = url.toString();
    };

    monthButtons.forEach((button) => {
      button.addEventListener('click', () => window.setTimeout(syncMonthRoute, 0));
      button.addEventListener('keydown', () => window.setTimeout(syncMonthRoute, 0));
    });
    syncMonthRoute();
  }

  section.dataset.localRoutesReady = 'true';
}

function normaliseCrystalGuideBirthstoneCopy(section) {
  if (!section || section.dataset.localBirthstoneCopyReady === 'true') return;

  const copy = new Map([
    ['.aucelia-crystal-personal-energy__eyebrow', 'Birthstones / Begin with a month'],
    ['.aucelia-crystal-personal-energy__header h2', 'First, see the colour of the month.'],
    ['.aucelia-crystal-personal-energy__introduction', 'Choose a month to change the image, then explore the recognised birthstone and Aucelia material direction.'],
    ['.aucelia-crystal-personal-energy__media-note', 'Twelve months, twelve material beginnings.'],
    ['.aucelia-crystal-personal-energy__panel-label', 'Choose your month'],
    ['.aucelia-crystal-personal-energy__month-panel h3', 'This month in colour and material.'],
    ['.aucelia-crystal-personal-energy__panel-copy', 'The recognised birthstone and Aucelia material direction are stated separately, so one is never presented as the other.']
  ]);
  copy.forEach((text, selector) => {
    const element = section.querySelector(selector);
    if (element) element.textContent = text;
  });

  const monthLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  section.querySelectorAll('.aucelia-crystal-personal-energy__months button[data-month]').forEach((button, index) => {
    if (monthLabels[index]) button.textContent = monthLabels[index];
  });

  section.dataset.localBirthstoneCopyReady = 'true';
}

function installMobileBirthstonePreview() {
  const section = document.querySelector('[data-aucelia-birthstone-story]');
  if (!section || section.dataset.mobileMonthPreviewReady === 'true') return;

  const birthstone = section.querySelector('.aucelia-crystal-personal-energy__birthstone');
  const media = section.querySelector('.aucelia-crystal-personal-energy__media');
  const panel = section.querySelector('.aucelia-crystal-personal-energy__month-panel');
  const mediaNote = section.querySelector('.aucelia-crystal-personal-energy__media-note');
  const months = section.querySelector('.aucelia-crystal-personal-energy__months');
  if (!birthstone || !media || !panel || !mediaNote || !months) return;

  section.dataset.mobileMonthPreviewReady = 'true';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const monthsOriginalPrevious = months.previousElementSibling;
  const mediaNoteOriginalPrevious = mediaNote.previousElementSibling;

  function syncLayout() {
    if (mobileQuery.matches) {
      if (media.parentElement !== panel || panel.firstElementChild !== media) {
        panel.insertBefore(media, panel.firstElementChild);
      }
      if (media.nextElementSibling !== mediaNote) media.insertAdjacentElement('afterend', mediaNote);
      if (mediaNote.nextElementSibling !== months) mediaNote.insertAdjacentElement('afterend', months);
      return;
    }

    if (monthsOriginalPrevious && months.previousElementSibling !== monthsOriginalPrevious) {
      monthsOriginalPrevious.insertAdjacentElement('afterend', months);
    }
    if (media.parentElement !== birthstone || media.nextElementSibling !== panel) {
      birthstone.insertBefore(media, panel);
    }
    if (mediaNoteOriginalPrevious && (mediaNote.parentElement !== media || mediaNote.previousElementSibling !== mediaNoteOriginalPrevious)) {
      mediaNoteOriginalPrevious.insertAdjacentElement('afterend', mediaNote);
    }
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncLayout);
  } else {
    mobileQuery.addListener(syncLayout);
  }
  syncLayout();
}

function removeDeferredCrystalGuideBlocks() {
  const section = document.querySelector('[data-aucelia-birthstone-story]');
  const more = section?.querySelector('.aucelia-crystal-personal-energy__more');
  const moreHeading = more?.querySelector('.aucelia-crystal-personal-energy__more-heading');
  const chapters = more?.querySelector('.aucelia-crystal-personal-energy__chapters');
  const completeDesigns = document.querySelector('.aucelia-crystal-design-row');

  moreHeading?.remove();
  chapters?.remove();
  more?.classList.add('is-guide-pruned');

  if (completeDesigns) {
    const shopifySection = completeDesigns.closest('.shopify-section');
    const placeholder = shopifySection || completeDesigns;
    placeholder.classList.add('section-aucelia-crystal-designer-cta');
    placeholder.innerHTML = '';
  }
}

function initializeCrystalGuideReview() {
  removeDeferredCrystalGuideBlocks();
  normaliseCrystalGuideRoutes();
  buildZodiacStory();
  normaliseCrystalGuideBirthstoneCopy(document.querySelector('[data-aucelia-birthstone-story]'));
  installMobileBirthstonePreview();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCrystalGuideReview, { once: true });
} else {
  initializeCrystalGuideReview();
}
